// 新协议
function kkmhhybrid_set_title (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "set_title",
    },
    param: {
      title: opt.title,
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}
// 旧协议
function kkhybrid_settitle (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "settitle",
    },
    param: {
      title: opt.title,
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}
/**
 * 展示提示<br>
 * kkmhhybrid://set_title{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=81821998}<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.title 动态更改的标题
 * @param {Function} opt.callback 回调函数
 */
function set_title (opt, criticalAppVersion) {
  if(!criticalAppVersion) {
    criticalAppVersion = window.kkBaseInfo.criticalAppVersion;
  }
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(!allow) {
    // 调用旧协议
    kkhybrid_settitle(opt);
  } else {
    kkmhhybrid_set_title(opt)
  }
}

export default set_title;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/set_title/index.js